(() => {
  const setActiveContent = (section, activeId) => {
    const contentEls = section.querySelectorAll(".content-tabs__content");

    contentEls.forEach((el) => el.classList.remove("active"));

    const activeContent = section.querySelector(
      `[data-block-id="${activeId}"].content-tabs__content`
    );

    if (activeContent) {
      activeContent.classList.add("active");
    }
  };

  // Move the active state to `targetTab`, updating the roving tabindex and
  // aria-selected on the whole tablist (ARIA tabs pattern) and revealing the
  // matching panel.
  const activateTab = (section, tabs, targetTab) => {
    if (targetTab.classList.contains("active")) return;

    tabs.forEach((tab) => {
      const isActive = tab === targetTab;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    setActiveContent(section, targetTab.dataset.blockId);
  };

  const toggleTab = (section) => {
    // Select by the stable role, not the presentation class (which CSS refactors rename).
    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateTab(section, tabs, tab);
      });

      tab.addEventListener("keydown", (event) => {
        let targetIndex = null;

        switch (event.key) {
          case "ArrowRight":
          case "ArrowDown":
            targetIndex = (index + 1) % tabs.length;
            break;
          case "ArrowLeft":
          case "ArrowUp":
            targetIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case "Home":
            targetIndex = 0;
            break;
          case "End":
            targetIndex = tabs.length - 1;
            break;
          case "Enter":
          case " ":
            event.preventDefault();
            activateTab(section, tabs, tab);
            return;
          default:
            return;
        }

        event.preventDefault();
        const targetTab = tabs[targetIndex];
        activateTab(section, tabs, targetTab);
        targetTab.focus();
      });
    });
  };

  const initCollapsibleBlock = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;
    const blocks = section.querySelectorAll(".content-tabs__collapsible");

    blocks.forEach((block) => {
      block.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(
          ".content-tabs__collapsible-toggle"
        );
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("content-tabs__collapsible-content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;

    toggleTab(section);
  };

  initSection(document.currentScript.parentElement);
  initCollapsibleBlock(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
